/**
 * Hijack state — pure UI marker.
 *
 * With JWT-backed hijack the token rotation is server-side via the
 * `parent_refresh_token` HttpOnly cookie. The frontend only needs to know
 * "am I currently impersonating someone?" to show the release banner.
 */

const HIJACKED_USER_KEY = "hijack_user_name";

export function markHijacked(targetUserName: string): void {
  localStorage.setItem(HIJACKED_USER_KEY, targetUserName);
}

export function clearHijackMarker(): void {
  localStorage.removeItem(HIJACKED_USER_KEY);
  // Also sweep up legacy keys from the pre-JWT deployment.
  localStorage.removeItem("hijack_original_token");
  sessionStorage.removeItem("hijack_original_access");
}

export function isHijacked(): boolean {
  return !!localStorage.getItem(HIJACKED_USER_KEY);
}

export function getHijackedUserName(): string | null {
  return localStorage.getItem(HIJACKED_USER_KEY);
}
